import { render, staticRenderFns } from "./serveInfoNew.vue?vue&type=template&id=3f99b0b0&scoped=true"
import script from "./serveInfoNew.vue?vue&type=script&lang=js"
export * from "./serveInfoNew.vue?vue&type=script&lang=js"
import style0 from "./serveInfoNew.vue?vue&type=style&index=0&id=3f99b0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f99b0b0",
  null
  
)

export default component.exports